import { render, staticRenderFns } from "./WorkCompleted.vue?vue&type=template&id=1922937a&scoped=true"
import script from "./WorkCompleted.vue?vue&type=script&lang=js"
export * from "./WorkCompleted.vue?vue&type=script&lang=js"
import style0 from "./WorkCompleted.vue?vue&type=style&index=0&id=1922937a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922937a",
  null
  
)

export default component.exports